<template>
  <van-dialog v-model="isShow" confirmButtonText="知道了" v-on="$listeners">
    <div id="submitted-dialog">
      <img src="/static/img/wechat-gongzhonghao.png" alt="部落小助手" class="code" />

      <div class="title">
        <template>
          <p>长按识别二维码，关注“部落小助手” </p>
          <p>有人喜欢你，第一时间通知你哦</p>
        </template>

      </div>

    </div>
  </van-dialog>
</template>

<script>
export default {
  name: 'AccelerateAduit',
  data () {
    return {
    }
  },
  model: {
    prop: 'isShowDialog',
    event: 'close'
  },
  props: {
    isShowDialog: Boolean
  },
  computed: {
    isShow: {
      get () {
        return this.isShowDialog
      },
      set () {
        this.$emit('close', false)
      }
    }
  }
}
</script>

<style lang="scss">
#submitted-dialog {
  text-align: center;
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;

  .title {
    margin-bottom: 20px;
    padding: 24px 0;
    color: #38383c;
    line-height: 44px;
    p {
      font-size: 26px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(155, 155, 161, 1);
      line-height: 40px;
    }
  }
  .tips {
    font-size: 24px;
    line-height: 36px;
  }
  .code {
    padding-top: 25px;
    margin: 10px;
    width: 411px;
    height: 411px;
  }
}
</style>
